module.exports = __webpack_public_path__ + "resources/img/img_tibero3_en.5c6b96534165ba06105745ca84b74b52.png";